<template>
  <div>
    <div v-for="(chapter,chapterIndex) in chapterDtos" :key="chapter.id">
      <div class="chapter-title">{{chapter.name}}</div>
      <el-card class="box-card" v-if="chapter.sectionDtos.length > 0">
        <div style="margin: -20px;border: 1px solid #EBEEF5;">
          <div class="section-item"
               v-for="(section,sectionIndex) in chapter.sectionDtos"
               :key = section.id
               @click="toResource(section)">
            <el-row :gutter="20" type="flex" align="middle">
              <el-col :span="1">
                <span class="section-item-icon">
                  <i v-if="section.targetType==='V'" class="el-icon-video-play"></i>
                  <i v-else-if="section.targetType==='D'" class="el-icon-document"></i>
                  <i v-else-if="section.targetType==='T'" class="el-icon-edit-outline"></i>
                </span>
              </el-col>
              <el-col :span="19" style="display: flex;align-items: center;margin-left: -10px!important;">
                <!-- 小节题目-->
                <span class="section-item-title">
                  {{section.title}}
                  <span v-if="section.targetType !== 'T'">
                    ({{section.target.duration | formatSecond}})
                  </span>
                  <span v-else>
                    <span v-if="section.target.limitTime">({{ section.target.limitTime | formatSecond}})</span>
                    <span v-else>({{'不限时'}})</span>
                  </span>
                </span>
                <!-- 是否免费-->
                <el-tag type="danger" effect="dark" size="mini" v-if="section.charge==='F' && userCourseProcess === null">试看</el-tag>
                <!-- 考试是否合格-->
                <el-tag type="success" effect="dark" size="mini" v-if="section.targetType==='T' && section.target.isPass === '1'">合格</el-tag>
                <el-tag type="danger" effect="dark" size="mini" v-if="section.targetType==='T' && section.target.isPass === '0'">不合格</el-tag>
                <!-- 资源类型-->
                <el-tag type="primary" effect="dark" size="mini" class="section-item-target_type">
                  <span v-if="section.targetType==='V'">视频</span>
                  <span v-else-if="section.targetType==='D'">文章</span>
                  <span v-else-if="section.targetType==='T'">考试</span>
                </el-tag>
              </el-col>
              <el-col :span="4">
                <div class="course-status">
                  <el-tag type="info" v-if="section.userSectionStudyStatus == 'N'">未开始</el-tag>
                  <el-tag v-else-if="section.userSectionStudyStatus == 'L' ">学习中</el-tag>
                  <el-tag type="success" v-else-if="section.userSectionStudyStatus == 'Y'">已完成</el-tag>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Chapter",
    props: {
      chapterDtos: Array,
      courseId: String,
      courseType: String,
      userCourseProcess: Number
    },
    data() {
      return {
        target: {},
      }
    },
    methods: {
      // 跳转到资源
      async toResource(section) {
        const id = section.id;
        const type = section.targetType;
        let resolveRouter = null;
        // V-视频 D文章 T试卷
        if (type === 'V') {
          // 判断点击的地方(课程详情、视频播放)
          let path = this.$route.path;
          if (path.includes('train')) {
            if (path.includes('trainVideo')) {
              this.$router.push({path:`/home/${this.courseType}Video/${this.courseId}/${id}`});
            }else {
              resolveRouter = this.$router.resolve({path: `/home/${this.courseType}Video/${this.courseId}/${id}`});
            }
          } else if (path.includes('edu')) {
            if (path.includes("eduVideo")) {
              this.$router.push({path:`/home/eduVideoTest/${this.courseId}/${id}`});
            }else {
              resolveRouter = this.$router.resolve({path: `/home/eduVideoTest/${this.courseId}/${id}`});
            }
          } else {
            //页面刷新
            this.$router.push({path: `/home`});
          }
        } else if (type === 'D') {
          // resolveRouter = this.$router.resolve({path: `/home/${this.courseType}Doc/${this.courseId}/${id}`});
          const {code, message} = await this.checkSection(id); // 先验证用户是否有小节权限
          if (code !== '2000') {
            this.$message.error(message); return;
          }
          resolveRouter = this.$router.resolve({path: `/home/${this.courseType}Doc/${this.courseId}/${id}`});
        } else if (type === 'T') {
          if (section.target.isPass !== '0') { // 考试合格或未开始
            const {code, message} = await this.checkSection(id); // 先验证用户是否有小节权限
            if (code !== '2000') {
              this.$message.error(message); return;
            }
            this.goToTest(this.courseId, id, section.targetId);
          } else { // 考试不合格
            this.openReTestConfirmBox(this.courseId, id, section.targetId);
          }
        } else {
          resolveRouter = this.$router.resolve({path: `/home`});
        }
        if (resolveRouter) window.open(resolveRouter.href, '_blank');
      },
      openReTestConfirmBox(courseId, sectionId, testId) {
        this.$confirm('是否选择重新考试?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          lockScroll: false
        }).then(async () => {
          // 清空作答相关数据
          const params = { courseId: courseId, sectionId: sectionId, testId: testId };
          const { success } = await this.$http.post('/business/web/test/resetTest', params);
          if (success) this.goToTest(courseId, sectionId, testId);
        }).catch(() => { });
      },
      async checkSection(sectionId) {
        return await this.$http.get('/business/web/section/check?sectionId=' + sectionId);
      },
      goToTest(courseId, sectionId, testId) {
        const params = {
          courseId: courseId,
          sectionId: sectionId,
          testId: testId
        };
        this.$router.push({ name: 'Test', params: params });
      }

    }
  }
</script>

<style lang="scss" scoped>

  .box-card {
    border: 0;
  }
  /*课程状态 的样式和位置*/
  .course-status {
    text-align: right;
    font-size: 16px;
    font-weight: 400;
    color: #999;
  }
  .chapter-title {
    padding: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #606266;
  }

  .section-item {
    padding: 15px 20px;
    background-color:#FFFFFF;
    font-size: 15px;
    cursor:pointer;
    user-select:none;
    &:hover {
      background: #E0EDF8;

      .section-item-icon {
        color: #409EFF;
      }
      .section-item-title {
        color: #409EFF;
      }
      .section-item-target_type {
        display: inline-block;
      }
    }
  }

  .section-item-icon {
    font-size: 20px;
  }

  .section-item-target_type {
    display: none;
  }

  .el-tag {
    margin-left: 10px;
  }
</style>
